$(document).ready(function() {
  var blogSwiper = new Swiper('.blog-swiper', {
    slidesPerView: 1,
    spaceBetween: 8,
    autoplay: false,
    loop: false,
    navigation: {
      nextEl: ".blog-swiper .swiper-button-next",
      prevEl: ".blog-swiper .swiper-button-prev",
    },
    breakpoints: {
      590: {
        slidesPerView: 2,
        spaceBetween: 8,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 8,
      }
    },
    on: {
      init: function () {
        //updateInViewClass(this);
      },
      slideChange: function () {
        //updateInViewClass(this);
      }
    }
  });
});
